import type { CosignatureDocumentType, CosignatureStatus } from "@/core/types";

import type { NoteAction } from "../../types";

export const DocumentTypeMap = {
  note: "Note",
  note_addendum: "Addendum",
} as const satisfies Record<CosignatureDocumentType, string>;

type ActionItem = { id: NoteAction; isDisabled?: boolean; label: string };

const VIEW_ONLY_ACTION_ITEMS = [
  { id: "review", label: "View" },
  { id: "cosign", isDisabled: true, label: "Approve & Co-Sign" },
  { id: "reject", isDisabled: true, label: "Reject Note" },
] as const satisfies ActionItem[];

const ALL_ACTION_ITEMS = [
  { id: "review", label: "Review" },
  { id: "cosign", label: "Approve & Co-Sign" },
  { id: "reject", label: "Reject Note" },
] as const satisfies ActionItem[];

export const ACTION_ITEMS_BY_STATUS = {
  pending: ALL_ACTION_ITEMS,
  rejected: VIEW_ONLY_ACTION_ITEMS,
  resubmitted: ALL_ACTION_ITEMS,
  signed: VIEW_ONLY_ACTION_ITEMS,
} as const satisfies Record<CosignatureStatus, ActionItem[]>;

export const URGENCY_THRESHOLD = 3;
